import { ReactNode } from "react";
import { ArrowLeft } from "lucide-react";
import { CashIsleLogo } from "./CashIsleLogo";
import { cn } from "@/lib/utils";

interface Props {
  onBack?: () => void;
  right?: ReactNode;
  curve?: boolean;
  className?: string;
  children?: ReactNode;
}

export const BrandHeader = ({ onBack, right, curve = true, className, children }: Props) => (
  <header
    className={cn(
      "bg-card-gradient text-primary-foreground px-5 pt-12 pb-8 relative",
      curve && "rounded-b-[2rem]",
      className
    )}
  >
    <div className="flex items-center justify-between">
      {onBack ? (
        <button
          onClick={onBack}
          aria-label="Back"
          className="h-9 w-9 -ml-1 flex items-center justify-center rounded-full hover:bg-white/10 transition-smooth"
        >
          <ArrowLeft className="h-5 w-5" />
        </button>
      ) : (
        <div className="w-9" />
      )}
      <CashIsleLogo size={64} className="drop-shadow-md" />
      <div className="min-w-9 flex justify-end">{right}</div>
    </div>
    {children}
  </header>
);
